import { useState } from "react";
import { Link } from "react-router-dom";
import { FaHome, FaBars, FaTimes, FaSearch } from "react-icons/fa";
import logo from "../assets/images/logo_quarkia.png";
import SearchBar from "./SearchBar";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full flex flex-col items-center sticky top-0 z-50 bg-[#231f2b]">
      {/* ====== TOP BAR ====== */}
      <div className="w-full max-w-7xl flex justify-between items-center px-6 py-4">
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Quarkia"
            className="h-14 md:h-16 w-auto object-contain"
          />
        </Link>

        <Link
          to="/login"
          className="hidden md:block bg-[#0b625f] hover:bg-[#007e7e] text-white font-nexa font-bold px-6 py-3 rounded-2xl transition-all shadow-md"
        >
          Iniciar sesión
        </Link>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-white text-3xl focus:outline-none"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* ====== MAIN NAVBAR ====== */}
      <div className="w-full bg-gray-600">
        <div className="w-full max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
          <div className="hidden md:flex items-center space-x-8 text-white text-[15px] font-medium">
            
            {/* 🏠 Ícono Home separado */}
            <Link
              to="/"
              className="flex items-center hover:text-[#00b3b3] transition text-lg"
              title="Inicio"
            >
              <FaHome />
            </Link>

            {/* Sobre nosotros */}
            <Link
              to="/sobrenosotros"
              className="font-nexa font-bold hover:text-[#00b3b3] transition"
            >
              Sobre nosotros
            </Link>

            <Link to="/servicios" className="font-nexa font-bold hover:text-[#00b3b3] transition">
              Servicios
            </Link>

            <Link to="/register" className="font-nexa font-bold hover:text-[#00b3b3] transition">
              Registro
            </Link>

            <Link to="/contactenos" className="font-nexa font-bold hover:text-[#00b3b3] transition">
              Contáctenos
            </Link>
          </div>

          {/* 🔍 Buscador */}
          <div className="hidden md:flex">
            <SearchBar />
          </div>
        </div>
      </div>

      {/* ====== MENÚ RESPONSIVO ====== */}
      {menuOpen && (
        <div className="md:hidden w-full bg-gray-700 bg-opacity-95 flex flex-col items-center space-y-4 py-6 text-white rounded-b-2xl transition-all duration-300">
          <Link
            to="/"
            onClick={() => setMenuOpen(false)}
            className="flex items-center space-x-2 hover:text-[#00b3b3] transition"
          >
            <FaHome />
            <span>Inicio</span>
          </Link>

          <Link
            to="/sobrenosotros"
            onClick={() => setMenuOpen(false)}
            className="font-nexa font-bold hover:text-[#00b3b3] transition"
          >
            Sobre nosotros
          </Link>

          <Link
            to="/servicios"
            onClick={() => setMenuOpen(false)}
            className="font-nexa font-bold hover:text-[#00b3b3] transition"
          >
            Servicios
          </Link>

          <Link
            to="/register"
            onClick={() => setMenuOpen(false)}
            className="font-nexa font-bold hover:text-[#00b3b3] transition"
          >
            Registro
          </Link>

          <Link
            to="/contactenos"
            onClick={() => setMenuOpen(false)}
            className="font-nexa font-bold hover:text-[#00b3b3] transition"
          >
            Contáctenos
          </Link>

          <Link
            to="/login"
            onClick={() => setMenuOpen(false)}
            className="bg-[#0b625f] hover:bg-[#007e7e] text-white font-semibold px-5 py-2 rounded-xl transition"
          >
            Iniciar sesión
          </Link>
        </div>
      )}
    </header>
  );
}
